<template>
  <v-tooltip bottom>
    <template
      slot="activator"
      slot-scope="{ on }"
    >
      <v-layout
        align-center
        v-on="on"
      >
        <BaseIcon
          :viewBox="'0 0 50 50'"
          :width="size"
          :height="size"
        >
          <CheckEyeIcon :icon-color="$vuetify.theme.sz_red" />
        </BaseIcon>
      </v-layout>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import CheckEyeIcon from '@/icons/CheckEyeIcon';

export default {
    name: 'FamilyCheckedMark',
    components: { BaseIcon, CheckEyeIcon },
    props: {
        tooltip: {
            required: true,
            type: String
        }
    },
    computed: {
        size () {
            if (this.$vuetify.breakpoint.smAndUp) {
                return 30;
            }
            return 24;
        }
    }
};
</script>

<style scoped></style>
